import { TemplateConfiguration } from '../models/template-configuration';
export class TemplateModeHelper {
  public static EDITION_MODE = 'edition';
  public static SHOW_MODE = 'edit';
}
